<template>
  <div>
    <ml-table bordered :data-source="dataSource" :columns="columns">
      <template slot="actions" slot-scope="text, record">
        <a-popconfirm
          v-if="maintenanceList.find(res => res.code === record.code) === undefined"
          :title="$t('page_mdc_setting_sure_delete')"
          @confirm="() => onDelete(record.key)"
        >
          <a href="javascript:;">{{ $t('delete') }}</a>
        </a-popconfirm>
      </template>
      <template slot="code" slot-scope="text, record">
        <template v-if="maintenanceList.find(res => res.code === record.code) === undefined">
          <a-select 
          show-search
          optionFilterProp="children"
          :value="text" @change="e => handleChange(e, record.key)" style="width: 100%;">
            <template v-for="(item,index) in maintainItemList">
              <a-select-option :value="item.code" :key="index">
                {{ item.code }}
              </a-select-option>
            </template>
          </a-select>
        </template>
        <template v-else>
          <div>{{ text }}</div>
        </template>
      </template>
      <template slot="isExecute" slot-scope="text, record">
        <a-switch :checked="text == 1" @change="e => handleCheck(e, record.key)" />
      </template>
    </ml-table>
    <a-button type="primary" style="width: 100%;margin: 8px 0;" @click="handleAdd()">{{$t('page_plan_maintenance_add_program')}}</a-button>
  </div>
</template>

<script>
const columns = [
  {
    title: 'actions',
    dataIndex: 'actions',
    ellipsis: true,
    width: 150,
    scopedSlots: { customRender: 'actions'}
  },
  {
    title: 'page_plan_maintenance_maintenance_item_code',
    dataIndex: 'code',
    ellipsis: true,
    width: 150,
    scopedSlots: { customRender: 'code'}
  },
  {
    title: 'page_plan_maintenance_items',
    dataIndex: 'name',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_plan_maintenance_requirements',
    dataIndex: 'requirement',
    ellipsis: true,
    width: 150
  },
  {
    title: 'remark',
    dataIndex: 'remark',
    ellipsis: true,
    width: 150
  },
  {
    title: 'page_plan_maintenance_maintenance_judgment',
    dataIndex: 'isExecute',
    ellipsis: true,
    width: 150,
    scopedSlots: { customRender: 'isExecute'}
  },
]
export default {
  data(){
    return{
      dataSource: [],
      count: 0,
      first: true
    }
  },
  props:{
    changeMaintenanceList:{
      type: Array,
      default: () => ([])
    },
    maintenanceList:{
      type: Array,
      default: () => ([])
    },
    maintainItemList:{
      type: Array,
      default: () => ([])
    }
  },
  watch:{
    changeMaintenanceList:{
      handler(){
        this.getData()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
  },
  methods:{
    getData(){
      this.dataSource = this.changeMaintenanceList
      this.count = this.dataSource.length
      if(this.first){
        this.$emit('change',this.dataSource,true)
        this.first = false
      }
    },
    onDelete(key) {
      const dataSource = [...this.dataSource];
      this.dataSource = dataSource.filter(item => item.key !== key);
      this.$emit('change',this.dataSource,false)
    },
    handleChange(value, key) {
      const has = this.dataSource.find(res => res.code === value)
      if(has != undefined){
        this.$message.warning(this.$t('page_plan_maintenance_not_choose_same'))
        return
      }
      const newData = [...this.dataSource];
      const target = newData.filter(item => key === item.key)[0];
      const data = this.maintainItemList.find(res => res.code === value)
      if (target && data) {
        target['itemId'] = data.id;
        target['code'] = value;
        target['name'] = data.name;
        target['requirement'] = data.requirement;
        target['remark'] = data.remark;
        this.dataSource = newData;
        this.$emit('change',this.dataSource,false)
      }
    },
    handleCheck(value, key){
      const newData = [...this.dataSource];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        target['isExecute'] = (value ? 1 : 0);
        this.dataSource = newData;
        this.$emit('change',this.dataSource,false)
      }
    },
    handleAdd() {
      const { count, dataSource } = this;
      const newData = {
        key: count,
        code: "",
        name: "",
        requirement: "",
        remark: "",
        isExecute: 1
      };
      this.first = false
      this.dataSource = [...dataSource, newData];
      this.count = count + 1;
    },
  }
}
</script>

<style>

</style>